import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function ProjectCardSkeleton() {
  return (
    <div className="project-card" style={{ marginBottom: "20px" }}>
      <Skeleton height={200} style={{ borderRadius: "10px" }} />
      <h4 style={{ marginTop: "10px" }}>
        <Skeleton width={`80%`} />
      </h4>
      <p>
        <Skeleton count={3} />
      </p>
      <div style={{ display: "flex", gap: "10px" }}>
        <Skeleton width={80} height={30} />
        <Skeleton width={80} height={30} />
      </div>
    </div>
  );
}

export default ProjectCardSkeleton;
